const headRowsTableActions = {
  id: 'ID',
  sponsor: 'Responsables',
  createdAt: 'Creado en',
  deadline: 'Fecha límite',
  equipment: 'Equipo',
  itemVerification: 'Verificación',
  place: 'Lugar',
  status: 'Status',
  action: 'Acción',
};

export default headRowsTableActions;
